import Button from "@mui/material/Button";
import { WHATSAPP_URL } from "config/constants";
import { PhoneCall } from "lucide-react";
import { useCallback } from "react";
import { GetList } from "types/data-content";

interface IServicePage {
  pageData: GetList;
}

const CTASection = ({ pageData }: IServicePage) => {
  const onScheduleClick = useCallback(() => {
    window.open(WHATSAPP_URL, "_blank");
  }, []);

  return (
    <section className="py-8 sm:py-20 px-6 bg-hero-gradient text-primary-foreground bg-gradient-primary">
      <div className="container mx-auto px-0 sm:max-w-4xl text-center">
        <p
          className="text-[16px] md:text-xl opacity-95 mb-5 sm:mb-10 leading-relaxed max-w-3xl mx-auto"
          dangerouslySetInnerHTML={{
            __html: pageData?.conclusionPageMarketing || "",
          }}
        />
        {pageData.productId.indexOf("#MES") === -1 && (
          <>
            <p className="text-lg mb-8 font-semibold">
              Pronto para impulsionar seus resultados?
            </p>

            <Button
              onClick={onScheduleClick}
              variant="contained"
              startIcon={<PhoneCall />}
              sx={{
                backgroundColor: "white",
                color: "primary.main",
                fontWeight: "bold",
                px: 4,
                py: 1.5,
                borderRadius: "50px",
                transition: "0.5s",
                "&:hover": {
                  backgroundColor: "rgba(255, 255, 255, 0.9)",
                  transform: "scale(1.05)",
                  transition: "0.5s",
                },
                "@media (max-width:480px)": {
                  fontSize: "14px",
                  maxWidth: "312px",
                  width: "100%",
                  alignSelf: "center",
                  py: 1.3,
                },
              }}
            >
              Quero Anunciar no Google
            </Button>
          </>
        )}
      </div>
    </section>
  );
};

export default CTASection;
